module.exports = new __parcel__URL__("emit_above_planet_v4-1.71fc444d.png").toString();